import React, { useEffect, useMemo } from "react";
import styles from "./style.module.css";
import { FormControlLabel, Typography, Radio, IconButton } from "@mui/material";
import { useTheme } from "@mui/styles";
import CustomFileField from "../../../../../components/FileField/CustomFileField";
import ImageInfoToolTip from "../../../../../components/ImageInfo/ImageInfo";
import CustomTextField from "../../../../../components/FormFields/TextField/TextField.component";
import UploaderImage from "../../../../../components/FileComponent/UploaderImage.component";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { OutlineButton } from "../../../../../components/Buttons/PrimaryButton";

const QuestionIncludeFields = ({
  index,
  changeData,
  data,
  errors,
  fieldLendth,
  handleRemoveOption,
  addOption,
  handlePress,
  isActive,
  isDuplicate
}) => {
  const theme = useTheme();

  const handleChange = (e, fieldName, questID) => {
    if (fieldName === "is_correct" || fieldName === "value") {
      changeData(
        index,
        {
          quest_id: questID,
          [fieldName]: e,
        },
        "options"
      );
    } else if (fieldName === "reward_points") {
      if (e >= 0) {
        changeData(index, { [fieldName]: e });
      }
    } else {
      changeData(index, { [fieldName]: e });
    }
  };
  return (
    <div>
      <div className={styles.formFlex}>
        <div className={styles.count}>
          <CustomFileField
            maxSize={10 * 1024 * 1024}
            type={["jpg", "png", "jpeg"]}
            defaultImage={data?.image}
            // name="image"
            accept={"image/*"}
            error={errors?.question_images}
            onChange={(file) => {
              if (file) {
                handleChange(file, "question_images");
              }
            }}
            disabled ={isActive && !isDuplicate}
            value={data?.question_images}
            render={({ value, url, error, ...rest }) => (
              <UploaderImage
              placeholder="Upload Image"
              Banner
                error={error}
                value={value}
                default_image={data?.image}
                label={
                  <>
                    Upload Image
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                url={url}
                {...rest}
              />
            )}
          />
          <div className={styles.imageGuide}>
            <Typography variant="subtitle1">Image Guide</Typography>
            <ImageInfoToolTip
              resolution={
                <div className={styles.new_line}>
                  <div> Resolution 1280px * 720px</div>

                  <div>Image size = 10MB</div>
                </div>
              }
            />
          </div>
        </div>
        <div className={styles.lowerWrap}>
          <div className={styles.formFlex}>
            <div className={styles.formGroup}>
              <CustomTextField
                disabled={isActive && !isDuplicate}
                type="number"
                isError={errors?.reward_points}
                errorText={errors?.reward_points}
                label={
                  <>
                    Reward Points{" "}
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={data?.reward_points}
                onTextChange={(text) => {
                  handleChange(text, "reward_points");
                }}
              />
            </div>
            {index !== 0 && (
              <div className={styles.wrap}>
                <IconButton
                  onClick={() => {
                    handlePress(index == 0 ? "-" : "-", index);
                  }}
                  disabled={isActive && !isDuplicate}
                  className={styles.btnCont}
                >
                  <DeleteIcon
                    // disabled={isActive}
                    onClick={() => {
                      handlePress(index == 0 ? "-" : "-", index);
                    }}
                    color="error"
                  />
                </IconButton>
              </div>
            )}
          </div>
          <div className={styles.formFlex}>
            <div className={styles.formGroup}>
              <CustomTextField
                disabled={isActive && !isDuplicate}
                isError={errors?.question}
                errorText={errors?.question}
                label={
                  <>
                    Question{" "}
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={data?.question}
                onTextChange={(text) => {
                  handleChange(text, "question");
                }}
              />
            </div>
          </div>
          <div className={styles.formFlex}>
            <div className={styles.formGroup}>
              <CustomTextField
                disabled={isActive && !isDuplicate}
                isError={errors?.description}
                errorText={errors?.description}
                label={
                  <>
                    Information related to question{" "}
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                // multiline
                // rows="3"
                value={data?.description}
                onTextChange={(text) => {
                  handleChange(text, "description");
                }}
              />
            </div>
          </div>
          <div className={styles.optionWrap}>
            <div className={styles.container}>
              <div className={styles.radio}>
                <Typography variant="subtitle1">
                  Select Correct Option
                </Typography>
              </div>
              <div className={styles.optionsField}>
                <Typography variant="subtitle1">Add Option</Typography>
              </div>
            </div>

            {data?.options?.map((key, optindex) => {
              return (
                <div
                  className={styles.container}
                  key={`quiz_options${optindex}`}
                >
                  <FormControlLabel
                    disabled={isActive && !isDuplicate}
                    control={
                      <Radio
                        checked={key?.is_correct}
                        onChange={() =>
                          handleChange(
                            !key?.is_correct,
                            "is_correct",
                            key?.quest_id
                          )
                        }
                        value={key?.is_correct}
                      />
                    }
                    className={styles.radio}
                    label=""
                  />
                  <CustomTextField
                    className={styles.optionsField}
                    isError={errors?.[`value_${optindex}`]}
                    errorText={errors?.[`value_${optindex}`]}
                    disabled={isActive && !isDuplicate}
                    label={
                      <>
                        {`Option ${optindex + 1}`}
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={key?.value}
                    onTextChange={(text) => {
                      handleChange(text, "value", key?.quest_id);
                    }}
                  />

                  <div className={styles.btnDelete}>
                    {optindex > 1 && (
                      <IconButton
                        className={styles.btnCont}
                        onClick={() => handleRemoveOption(index, key?.quest_id)}
                        disabled={isActive && !isDuplicate}
                      >
                        <DeleteIcon
                          color="error"
                          style={{ marginLeft: "10px" }}
                        />
                      </IconButton>
                    )}
                  </div>
                </div>
              );
            })}
            <div className={styles.titleWrap}>
              <Typography variant="subtitle1">
                Max 4 Options can be added
              </Typography>
            </div>
            <div className={styles.btnWrap}>
              {data?.options?.length < 4 && (
                <OutlineButton
                  disabled={isActive && !isDuplicate}
                  variant="outlined"
                  sx={{ mr: 1 }}
                  onClick={(e) => addOption(index)}
                >
                  ADD OPTION
                </OutlineButton>
              )}
              <OutlineButton
                disabled={isActive && !isDuplicate}
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={(e) => handlePress("ADDITION", 0)}
              >
                ADD NEXT QUESTION
              </OutlineButton>
            </div>
          </div>
        </div>
      </div>
      {fieldLendth !== index + 1 && (
        <div className={styles.horizontalLine}></div>
      )}
    </div>
  );
};

export default QuestionIncludeFields;
